import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=2eaef8cb&"
import script from "./NewGroup.vue?vue&type=script&lang=js&"
export * from "./NewGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports